/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';

import { NextSalesPotentialDto } from '../../registration/models';

export enum SalesPotentialActionTypes {
  LoadSalesPotentialsRequest = '[SalesPotential] Load sales potentials request',
  LoadSalesPotentialsSuccess = '[SalesPotential] Load sales potentials success',
  LoadSalesPotentialsFailed = '[SalesPotential] Load sales potentials failed',
  DeleteSalesPotentialRequest = '[SalesPotential] Delete sales potential request',
  DeleteSalesPotentialSuccess = '[SalesPotential] Delete sales potential success',
  DeleteSalesPotentialFailed = '[SalesPotential] Delete sales potential failed',
  UpsertSalesPotentialRequest = '[SalesPotential] Upsert sales potential request',
  UpsertSalesPotentialSuccess = '[SalesPotential] Upsert sales potential success',
  UpsertSalesPotentialFailed = '[SalesPotential] Upsert sales potential failed',
}

export class LoadSalesPotentialsRequest implements Action {
  readonly type = SalesPotentialActionTypes.LoadSalesPotentialsRequest;
  constructor(public payload: number) {}
}

export class LoadSalesPotentialsSuccess implements Action {
  readonly type = SalesPotentialActionTypes.LoadSalesPotentialsSuccess;
  constructor(public payload: NextSalesPotentialDto[]) {}
}

export class LoadSalesPotentialsFailed implements Action {
  readonly type = SalesPotentialActionTypes.LoadSalesPotentialsFailed;
  constructor(public payload: Error) {}
}

export class DeleteSalesPotentialRequest implements Action {
  readonly type = SalesPotentialActionTypes.DeleteSalesPotentialRequest;
  constructor(public payload: number) {}
}

export class DeleteSalesPotentialSuccess implements Action {
  readonly type = SalesPotentialActionTypes.DeleteSalesPotentialSuccess;
  constructor(public payload: number) {}
}

export class DeleteSalesPotentialFailed implements Action {
  readonly type = SalesPotentialActionTypes.DeleteSalesPotentialFailed;
  constructor(public payload: Error) {}
}

export interface UpsertSalesPotentialRequest {
  id?: number;
  cropId: number;
  areaInHectares: number;
  year: number;
  salesPotentialGbm: boolean;
  salesPotentialBem: boolean;
  salesPotentialSeed: boolean;
  isSkal: boolean;
}

export class UpsertSalesPotentialRequestAction implements Action {
  readonly type = SalesPotentialActionTypes.UpsertSalesPotentialRequest;
  constructor(public payload: UpsertSalesPotentialRequest) {}
}

export class UpsertSalesPotentialSuccess implements Action {
  readonly type = SalesPotentialActionTypes.UpsertSalesPotentialSuccess;
  constructor(public payload: NextSalesPotentialDto) {}
}

export class UpsertSalesPotentialFailed implements Action {
  readonly type = SalesPotentialActionTypes.UpsertSalesPotentialFailed;
  constructor(public payload: Error) {}
}

export type SalesPotentialActions =
  | LoadSalesPotentialsRequest
  | LoadSalesPotentialsSuccess
  | LoadSalesPotentialsFailed
  | DeleteSalesPotentialRequest
  | DeleteSalesPotentialSuccess
  | DeleteSalesPotentialFailed
  | UpsertSalesPotentialRequestAction
  | UpsertSalesPotentialSuccess
  | UpsertSalesPotentialFailed;
